import { formatISO } from "date-fns";
import { HealthStatusType } from "./HealthStatusType";

const EMPTY_DATETIME =  formatISO(new Date(1901, 1, 1, 0, 0, 0));

export default class HealthInfoDetail 
{
    constructor(serviceName, updateDateTime, updateStatus, updateMessages)
    {
        this.serviceName = serviceName || "";
        this.updateDateTime = updateDateTime || EMPTY_DATETIME;
        this.updateStatus = updateStatus || HealthStatusType.UNKNOWN;
        this.updateMessages = updateMessages || [];

        this.toEmptyDate = this.toEmptyDate.bind(this);
    }

    toEmptyDate()
    {
        return EMPTY_DATETIME;
    }



}
